import { IRejectList, TCpiFilter, TCutPanelInspectionDB, TRESPONSE_GetCutPanelInspectionInfo } from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum CutPanelInspectionDBActionTypes {
  InitializeCutPanelInspectionDB = 'InitializeCutPanelInspectionDB',
  SetCutPanelInspectionDB = 'SetCutPanelInspectionDB',
  UpdateRecentRecutsList = 'UpdateRecentRecutsList',
  FetchInspectionCounts = 'FetchInspectionCounts',
  FetchInspectionCountsSuccess = 'FetchInspectionCountsSuccess',
  SetSelectedMasterCutDisplayTag = 'SetSelectedMasterCutDisplayTag',
  CutPanelInspectionNoAction = 'CutPanelInspectionNoAction',
}

export class InitializeCutPanelInspectionDB implements Action {
  readonly type = CutPanelInspectionDBActionTypes.InitializeCutPanelInspectionDB;
  constructor() {}
}

export class SetCutPanelInspectionDB implements Action {
  readonly type = CutPanelInspectionDBActionTypes.SetCutPanelInspectionDB;
  constructor(public db: TCutPanelInspectionDB) {}
}

export class UpdateRecentRecutsList implements Action {
  readonly type = CutPanelInspectionDBActionTypes.UpdateRecentRecutsList;
  constructor(public list: IRejectList[]) {}
}

export class FetchInspectionCounts implements Action {
  readonly type = CutPanelInspectionDBActionTypes.FetchInspectionCounts;
  constructor(public filters: TCpiFilter[]) {}
}

export class FetchInspectionCountsSuccess implements Action {
  readonly type = CutPanelInspectionDBActionTypes.FetchInspectionCountsSuccess;
  constructor(public res: TRESPONSE_GetCutPanelInspectionInfo['cutPanelInspectionInfoCount']) {}
}

export class SetSelectedMasterCutDisplayTag implements Action {
  readonly type = CutPanelInspectionDBActionTypes.SetSelectedMasterCutDisplayTag;
  constructor(public cutDisplayTag: TCutPanelInspectionDB['selectedMasterCutDisplayTag']) {}
}

export class CutPanelInspectionNoAction implements Action {
  readonly type = CutPanelInspectionDBActionTypes.CutPanelInspectionNoAction;
  constructor() {}
}

export type TCutPanelInspectionActions =
  | InitializeCutPanelInspectionDB
  | SetCutPanelInspectionDB
  | UpdateRecentRecutsList
  | FetchInspectionCounts
  | FetchInspectionCountsSuccess
  | SetSelectedMasterCutDisplayTag
  | CutPanelInspectionNoAction;
